const values = {
  TLS_SERVER: "TLS_SERVER",
  TLS_CLIENT: "TLS_CLIENT",
  SMIME: "SMIME"
};
export default Object.freeze(values);
